import { render, staticRenderFns } from "./InfoLinkButton.vue?vue&type=template&id=247e961c&scoped=true&"
import script from "./InfoLinkButton.vue?vue&type=script&lang=js&"
export * from "./InfoLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./InfoLinkButton.vue?vue&type=style&index=0&id=247e961c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247e961c",
  null
  
)

export default component.exports